import React from "react";

var InformationIcon = function InformationIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "40",
    viewBox: "0 0 20 40",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 28C7.125 28 4.5 26.5 3.0625 24C1.625 21.5312 1.625 18.5 3.0625 16C4.5 13.5312 7.125 12 10 12C12.8438 12 15.4688 13.5312 16.9062 16C18.3438 18.5 18.3438 21.5312 16.9062 24C15.4688 26.5 12.8438 28 10 28ZM8.75 22.5C8.3125 22.5 8 22.8438 8 23.25C8 23.6875 8.3125 24 8.75 24H11.25C11.6562 24 12 23.6875 12 23.25C12 22.8438 11.6562 22.5 11.25 22.5H11V19.75C11 19.3438 10.6562 19 10.25 19H8.75C8.3125 19 8 19.3438 8 19.75C8 20.1875 8.3125 20.5 8.75 20.5H9.5V22.5H8.75ZM10 16C9.4375 16 9 16.4688 9 17C9 17.5625 9.4375 18 10 18C10.5312 18 11 17.5625 11 17C11 16.4688 10.5312 16 10 16Z",
    fill: "#005DA2"
  }));
};

export default InformationIcon;